<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>

    <merchant-transaction-filter
      :search="search"
      v-on:clearSearchParent="clearSearch"
      v-on:getDataParent="getData"
      :loading="loading"
    />

    <v-data-table
      :headers="headers"
      fixed-header
      :items="allData"
      :options.sync="options"
      :server-items-length="totalData"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      item-key="trx_id"
      sort-by="trx_datetime"
      :sort-desc="true"
      :style="{ padding: '10px', height: '70vh' }"
    >
      <template v-slot:top>
        <table-top-vue
          :loading="loading"
          :listButton="listButton"
          v-on:getDataParent="getData"
          v-on:exportItemParent="exportItem"
        />
      </template>
      <template v-slot:item="{ item, index }">
        <table-item
          :options="options"
          :selectedRow="selectedRow"
          :item="item"
          :index="index"
          v-on:selectRowParent="selectRow"
          v-on:viewItemParent="viewItem"
        />
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="500px">
      <table-detail :editedItem="editedItem" v-on:closeParent="close" />
    </v-dialog>
  </v-card>
</template>

<script>
import { getDate, date, showAlert } from '../../lib/helpers';

export default {
  components: {
    TableDetail: () =>
      import('../../components/table/CptsTransactionDetail.vue'),
    TableTopVue: () => import('../../components/table/TableTop.vue'),
    TableItem: () => import('../../components/table/CptsTransactionItem.vue'),
    MerchantTransactionFilter: () =>
      import('../../components/table/CptsTransactionFilter.vue'),
  },
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonDotsExt: [
        {
          link: 'exportItemParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    isFirstLoad: true,
    options: {},
    view: false,
    show: false,
    dialog: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'trx_id',
        sortable: false,
        width: '10',
      },
      {
        text: 'Transaction PAN',
        value: 'trx_pan',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Invoice Number',
        value: 'invoice_number',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Merchant Name',
        value: 'merchant_name',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'MID',
        value: 'mid',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Merchant PAN',
        value: 'mpan',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Reff ID',
        value: 'rrn',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Transaction Type',
        value: 'trx_type',
        width: '100',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Issuer Name',
        value: 'issuer_name',
        width: '100',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Customer PAN',
        value: 'customer_pan',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Payment Type',
        value: 'payment_type',
        width: '100',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Acquirer Name',
        value: 'payment_channel',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Amount',
        value: 'amount',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'MDR',
        value: 'amount_mdr',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Net Amount',
        value: 'amount_net',
        width: '150',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Transaction Date',
        value: 'trx_datetime',
        width: '150',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Status Transaksi',
        value: 'status',
        width: '100',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Settlement Status',
        value: 'settlement_status',
        width: '100',
        sortable: false,
        align: 'center',
      },
      { text: 'Action', value: 'actions', sortable: false },
    ],
    search: {
      trx_datetime: [],
      payment_type: '',
      rrn: '',
      mid: '',
      status: '',
      trx_pan: '',
      invoice_number: '',
    },
    editedItem: {
      bill_num: '',
      merchant_name: '',
      mid: '',
      mpan: '',
      rrn: '',
      qr_method: '',
      qr_type: '',
      trx_type: '',
      customer_pan: '',
      payment_method: '',
      payment_type: '',
      payment_channel: '',
      amount: '',
      currency: '',
      amount_mdr: '',
      net_amount: '',
      trx_datetime: '',
      status: '',
      settlement_status: '',
    },
    selectedRow: '',
    editedIndex: -1,
  }),

  computed: {
    allData() {
      return this.$store.state.report.inputerCptsTransaction.allData;
    },
    detailData() {
      return this.$store.state.report.inputerCptsTransaction.item;
    },
    totalData() {
      return this.$store.state.report.inputerCptsTransaction.totalData;
    },
    totalPage() {
      return this.$store.state.report.inputerCptsTransaction.totalPage;
    },
    loading() {
      return this.$store.state.report.inputerCptsTransaction.loading;
    },
    flashError: {
      get() {
        return this.$store.state.report.inputerCptsTransaction.flashError;
      },
      set() {
        this.$store.commit(
          'report/inputerCptsTransaction/setFlashErrorMessage',
          ''
        );
      },
    },
    flashErrorMessage() {
      return this.$store.state.report.inputerCptsTransaction.flashErrorMessage;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('report/inputerCptsTransaction/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    getData() {
      if (this.search.trx_datetime.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('report/inputerCptsTransaction/clearData');
      } else {
        this.$store.commit(
          'report/inputerCptsTransaction/setFlashErrorMessage',
          ''
        );
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('report/inputerCptsTransaction/getData', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    async viewItem(itemId) {
      await this.$store
        .dispatch('report/inputerCptsTransaction/getDetail', {
          id: itemId,
          date,
        })
        .then(() => {
          if (!this.loading && this.detailData != null) {
            this.editedIndex = itemId;
          }
          this.editedItem = { ...this.detailData };
          this.view = true;
          this.editedIndex = -2;
          this.dialog = true;
        });
    },
    close() {
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit(
        'report/inputerCptsTransaction/setFlashErrorMessage',
        ''
      );
    },

    clearSearch() {
      this.search.trx_datetime = [];
      this.search.payment_type = '';
      this.search.rrn = '';
      this.search.mid = '';
      this.search.status = '';
      this.search.trx_pan = '';
      this.search.invoice_number = '';

      this.$nextTick(() => {
        this.$store.commit('report/inputerCptsTransaction/clearData');
        this.$store.commit('report/clearMerchant');
      });
    },

    getDate,

    exportItem() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('report/inputerCptsTransaction/clearData');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        this.$store.dispatch('exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          exportUrl: 'api/v1/export/export-inputer-cpts-transaction/index',
          exportController: 'export-inputer-cpts-transaction',
        });
      }
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
